import ApiService from './api';

/**
 * @deprecated Use statsApi from '../api/statsApi' for statistics data.
 * This service is kept only for user-related endpoints that are not part of the new statistics system.
 */
class StatisticsService extends ApiService {
  constructor() {
    super('/stats');
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getGeneralStats(params = {}) {
    console.warn('[StatisticsService] getGeneralStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/general', params);
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getLoadsStats(params = {}) {
    console.warn('[StatisticsService] getLoadsStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/loads', params);
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getUsersStats(params = {}) {
    console.warn('[StatisticsService] getUsersStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/users', params);
  }

  async getUsersCount() {
    const res = await this.get('/users/count');
    return res;
  }

  async getUsersTop(params = {}) {
    return await this.get('/users/top', params);
  }

  async getUsersByRole() {
    return await this.get('/users/by-role');
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getCustomersStats(params = {}) {
    console.warn('[StatisticsService] getCustomersStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/customers', params);
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getCarriersStats(params = {}) {
    console.warn('[StatisticsService] getCarriersStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/carriers', params);
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getPaymentsStats(params = {}) {
    console.warn('[StatisticsService] getPaymentsStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/payments', params);
  }

  /**
   * @deprecated Use statsApi.getStats() instead
   */
  async getDashboardStats(params = {}) {
    console.warn('[StatisticsService] getDashboardStats is deprecated. Use statsApi.getStats() instead.');
    return await this.get('/dashboard', params);
  }

  /**
   * @deprecated Use statsApi.getStats() with year range instead
   */
  async getTopCardsStats() {
    console.warn('[StatisticsService] getTopCardsStats is deprecated. Use statsApi.getStats() with year range instead.');
    return await this.get('/top-cards');
  }
}

export default new StatisticsService();
